var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifierIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.86 85.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 1.5px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #5e7db8;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.21,85.11c13.2,0,23.9-10.7,23.9-23.9s-10.7-23.9-23.9-23.9-23.9,10.7-23.9,23.9,10.7,23.9,23.9,23.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12,
    y: 12,
    width: 11.25,
    height: 11.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "45.74 12 45.74 23.24 34.49 23.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "23.24 45.74 12 45.74 12 34.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.99,37.68c-9.81,1.75-17.56,9.5-19.32,19.31H.75V.75h56.24v36.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.74,42.99c-.99.84-1.91,1.76-2.76,2.75h-8.49v-11.25h11.25v8.49Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "52.35 60.73 56.33 66.42 71.23 55.99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifierIcon1);
export default __webpack_public_path__ + "static/media/verifier-icon-1.5581466af83949bfbc6c84eba20e499a.svg";
export { ForwardRef as ReactComponent };